import Localstorage from '../utils/localStorageUtil'
// import * as GlobalServer from '../api/global'
import Config from '../../src/config/app'
import {authCookie} from "../utils/enums";

export default {
   async beforeCreate () {
       if (this.$route && this.$route.query.from === 'schoolCenter') {
           return false
       }
        const cur_time = Localstorage.getCurTime()
        this.$store.state.log = cur_time
        // 判断当前是否存在存token时间
        // 如果不存在，删除历史token
        // 如果存在判断是否大于一天，大于则删除当前历史token
        // 或者如果校区不一样则删除token
        const school_id = this.$route.query.school_id
        if(!cur_time || (Date.parse(new Date()) - cur_time > 1000*60*60*24) || Localstorage.getSchoolId()!==school_id) {
            Localstorage.getToken() && Localstorage.removeToken()
            if(school_id){
                Localstorage.setSchoolId(school_id)
            }
        }
        // 路径存在token直接存入cookie
        if(this.$route && this.$route.query.token && this.$route.query.client_id){
            this.$cookie.set(authCookie.token, this.$route.query.token, { expires: 30, domain: Config.domain })
            this.$cookie.set(authCookie.client_id, this.$route.query.client_id, { expires: 30, domain: Config.domain })
        }

        const path = this.$route.fullPath
        const url = path
        if ((this.$cookie.get(authCookie.token) && this.$cookie.get(authCookie.client_id))  &&
           (this.$store.state.initConfig.school_id || this.$route.query.school_id)) {
           // console.log('可以访问')
        } else if (path.indexOf('access_token=') > -1) {
            try {
                const tokenData = url.split('_token=')[1]
                const token = tokenData.slice(0, tokenData.indexOf('&'))
                Localstorage.setToken(token)
                Localstorage.setCurTime(Date.parse(new Date()))

                // 设置cookie
                this.$cookie.set(authCookie.token, token, { expires: 30, domain: Config.domain })
                this.$cookie.set(authCookie.client_id, Config.client_id, { expires: 30, domain: Config.domain })


                let stateData = url.split('state=')[1]
                stateData = stateData.slice(0, tokenData.indexOf('&'))
                const stateParams = this.$utils.getQuery(stateData)
                const path =  stateParams.path
                delete stateParams.path
                const stateString =  this.$utils.query2String(stateParams)

                this.$store.state.initConfig.school_id = `${stateParams.school_id}`
                const web = `${window.location.protocol}//${window.location.hostname}${path?'/'+path:''}?${stateString}`
                console.log(web)
                window.location.href = web
            }catch (e) {
                this.$message.error(e)
            }
        } else {
            // window.location.href = Config.loginUrl + this.$utils.newQuery({path: this.$route.path.slice(1), ...this.$route.query})
        }
       if (this.$cookie.get(authCookie.token) && !this.$store.state.token){
           this.$store.state.token = this.$cookie.get(authCookie.token)
       }
       // 设置初始化配置
       if(this.$route && this.$route.query && Object.keys(this.$route.query).length>0) {
           this.$store.dispatch('setInitConfig', {
               school_id: this.$route.query.school_id,
               ...this.$route.query
           })
       }
    },
    mounted() {
       window.Global_Router = this.$route
        // 监听全局事件
        // this.eventsList && getMessage(this.eventsList)
        const self = this

        window.addEventListener("storage", function(ev){
            console.log('main监听本地storage变化==>', ev)
            // if (ev.key === 'closeWindow') {
            //     window.location.href="about:blank"
            //     window.close()
            // }
            // 当前打开的课件/如果有被打开，就将其他的关闭
            const fn = setTimeout(()=>{
                let id = self.$route.query.id
                if(self.$route.query.is_practice){id = self.$route.query.practice_id}
                if (ev.key === 'unique' && localStorage.getItem('openWindow') === id) {
                    window.location.href="about:blank"
                    window.close()
                }
                clearTimeout(fn)
            }, 800)
        });
    },
}
